import PropTypes from 'prop-types';
import grade from './grade';
import availabilityLocations from './availabilityLocations';
import orgUnit from './orgUnit';
import assignmentLocation from './assignmentLocation';
import postCodeAnywhereLocation from '../external/postCodeAnywhereLocation';

const locationsForPosting = PropTypes.shape({
  assignments: PropTypes.arrayOf(assignmentLocation).isRequired,
  availabilities: PropTypes.arrayOf(availabilityLocations).isRequired,
  visitsTotal: PropTypes.number.isRequired,
  visitsCompleted: PropTypes.number.isRequired,
  clinicianLocation: postCodeAnywhereLocation,
  clinicianName: PropTypes.string.isRequired,
  clinicianPhoneNumber: PropTypes.string,
  clinicianColor: PropTypes.string.isRequired,
  clinicianId: PropTypes.number.isRequired,
  ragCapacity: PropTypes.number.isRequired,
  grade: grade.isRequired,
  orgUnit: orgUnit.isRequired,
});

export default locationsForPosting;
